export default __webpack_public_path__ + "images/reset.8932ff48e429523d5f275fc753edc16d.svg";